/* eslint-disable */
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,

  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import RemoveCircleOutlineOutlinedIcon from "@mui/icons-material/RemoveCircleOutlineOutlined";
import { useEffect, useState } from "react";
import { getConfiguracion } from "../../services/ConfiguracionService";
import { v4 as uuidv4 } from 'uuid';
import WaitingDialog from "../../utils/WaitingDialog";

const initialState = {
  esferaDesde: 0,
  esferaHasta: 0,
  cilindroDesde: 0,
  cilindroHasta: 0,
  costoPesos: 0,
  costoDolares: 0,
  valorDolar: 0,
  porcentajeDescuento: 0,
  costoReal: 0,
  futContado: 0,
  precioVentaContado: 0,
  futLista: 0,
  precioVentaLista: 0,
  tasaIva: 21, // 21% IVA por defecto
  correccionesList: [],
};

const nameItemText = "Rango";
//
// ########################################################################### 
//
const RangoDialog = ({
  onSave,
  onClose,
  itemCrud,
  actionCrud,
  setMessage,
  setShowMessage,
  rangosList
}) => {
  const [itemCrudLocal, setItemCrudLocal] = useState(initialState);
  const [isDoingSomething, setIsDoingSomething] = useState(false);

  //
  // ################################################################################
  //
  useEffect(() => {
    loadConfiguracion();
    if (actionCrud === "new") {
      setItemCrudLocal(initialState);
    } else {
      setItemCrudLocal(itemCrud);
    }
  }, []);

  //
  // ################################################################################
  //
  const loadConfiguracion = async () => {
    setIsDoingSomething(true);
    const response = await getConfiguracion();
    if (response.ok) {
      setIsDoingSomething(false);
      let _response = response.data.data;
      setItemCrudLocal((prev) => ({
        ...prev,
        valorDolar: _response[0].valor_dolar,
        tasaIva: _response[0].valor_tasa_iva_lc,
      }));
    } else {
      setIsDoingSomething(false);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const handleCloseDialog = () => {
    onClose();
  };
  //
  // ################################################################################
  //
  const handleChange = (e) => {
    const { name, type, checked, value } = e.target;
    setItemCrudLocal((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };
  //
  // ################################################################################
  //
  const handleSave = () => {
    if (actionCrud === "new" || actionCrud === "update") {
      if (itemCrudLocal.esferaDesde < -30 || itemCrudLocal.esferaDesde > 30 || (itemCrudLocal.esferaDesde * 100) % 25 != 0) {
        setMessage({
          severity: "error",
          messageText: "El valor de la Esfera Desde no es válido",
        });
        setShowMessage(true);
        return;
      }
      if (itemCrudLocal.esferaHasta < -30 || itemCrudLocal.esferaHasta > 30 || (itemCrudLocal.esferaHasta * 100) % 25 != 0) {
        setMessage({
          severity: "error",
          messageText: "El valor de la Esfera Hasta no es válido",
        });
        setShowMessage(true);
        return;
      }
      if (itemCrudLocal.cilindroDesde < -10 || itemCrudLocal.cilindroDesde > 0 || (Math.round(itemCrudLocal.cilindroDesde * 100) % 25) !== 0) {
        setMessage({
          severity: "error",
          messageText: "El valor del Cilindro Desde no es válido (en lentes de contacto el cilindro va de -10 a 0)",
        });
        setShowMessage(true);
        return;
      }
      if (itemCrudLocal.cilindroHasta < -10 || itemCrudLocal.cilindroHasta > 0 || (Math.round(itemCrudLocal.cilindroHasta * 100) % 25) !== 0) {
        setMessage({
          severity: "error",
          messageText: "El valor del Cilindro Hasta no es válido (en lentes de contacto el cilindro va de -10 a 0)",
        });
        setShowMessage(true);
        return;
      }
      if (itemCrudLocal.costoPesos === 0) {
        setMessage({
          severity: "error",
          messageText: "Debes ingresar el Precio de Costo en pesos",
        });
        setShowMessage(true);
        return;
      }
      if (itemCrudLocal.costoDolares === 0) {
        setMessage({
          severity: "error",
          messageText: "Debes ingresar el Precio de Costo en dólares",
        });
        setShowMessage(true);
        return;
      }

      if (rangosList.some(
        rango => rango.esfera_desde <= itemCrudLocal.esferaHasta
          && rango.esfera_hasta >= itemCrudLocal.esferaDesde
          && rango.cilindro_desde <= itemCrudLocal.cilindroHasta
          && rango.cilindro_hasta >= itemCrudLocal.cilindroDesde
          && rango.id !== itemCrudLocal.id
      )) {
        setMessage({
          severity: "error",
          messageText: "El Rango que intentas ingresar se superpone con otro ya registrado",
        });
        setShowMessage(true);
        return;
      }
    }
    save();
  };
  //
  // ########################################################################## 
  //
  const save = async () => {
    let _id = uuidv4();
    let _itemCrud = {
      esfera_desde: parseFloat(itemCrudLocal.esferaDesde),
      esfera_hasta: parseFloat(itemCrudLocal.esferaHasta),
      cilindro_desde: parseFloat(itemCrudLocal.cilindroDesde),
      cilindro_hasta: parseFloat(itemCrudLocal.cilindroHasta),
      costo_pesos: parseFloat(itemCrudLocal.costoPesos),
      costo_dolares: parseFloat(itemCrudLocal.costoDolares),
      valor_dolar: parseFloat(itemCrudLocal.valorDolar),
      porcentaje_descuento: parseFloat(itemCrudLocal.porcentajeDescuento),
      costo_real: parseFloat(itemCrudLocal.costoReal),
      fut_contado: parseFloat(itemCrudLocal.futContado),
      precio_venta_contado: parseFloat(itemCrudLocal.precioVentaContado),
      fut_lista: parseFloat(itemCrudLocal.futLista),
      precio_venta_lista: parseFloat(itemCrudLocal.precioVentaLista),
      correcciones_list: itemCrudLocal.correccionesList,
    };
    if (actionCrud !== "new") {
      _itemCrud.id = itemCrud.id;
    } else {
      _itemCrud.id = _id;
    }
    onSave(_itemCrud, actionCrud);
    setIsDoingSomething(false);
    if (actionCrud !== "new") {
      handleCloseDialog();
    }
    setItemCrudLocal(initialState);
  };
  //
  // ########################################################################## 
  //
  const handleCalculate = (par_origen) => {
    setItemCrudLocal((prev) => {
      const next = { ...prev };
      const toNum = (v) => {
        const n = Number(v);
        return Number.isFinite(n) ? n : 0;
      };
      const tasaIva = toNum(prev.tasaIva) || 21;
      const factorIva = 1 + (tasaIva / 100);
      // Me aseguro que los valores sean numéricos
      next.costoPesos = toNum(next.costoPesos);
      next.costoDolares = toNum(next.costoDolares);
      next.valorDolar = toNum(next.valorDolar);
      next.porcentajeDescuento = toNum(next.porcentajeDescuento);
      next.costoReal = toNum(next.costoReal);
      next.futContado = toNum(next.futContado);
      next.precioVentaContado = toNum(next.precioVentaContado);
      next.futLista = toNum(next.futLista);
      next.precioVentaLista = toNum(next.precioVentaLista);

      if (par_origen === "costoPesos" || par_origen === "valorDolar") {
        // costoDolares depende de costoPesos y valorDolar
        next.costoDolares = next.valorDolar !== 0
          ? Number((next.costoPesos / next.valorDolar).toFixed(4))
          : 0;
        // costoReal depende de costoPesos y %desc
        next.costoReal = Number((next.costoPesos - (next.costoPesos * next.porcentajeDescuento / 100)).toFixed(2));
        // precios dependen de costoReal y factores
        next.precioVentaContado = Number((next.costoReal * next.futContado * factorIva).toFixed(2));
        next.precioVentaLista = Number((next.costoReal * next.futLista * factorIva).toFixed(2));
      } else if (par_origen === "costoDolares") {
        // costoPesos depende de costoDolares y valorDolar
        next.costoPesos = Number((next.costoDolares * next.valorDolar).toFixed(2));
        next.costoReal = Number((next.costoPesos - (next.costoPesos * next.porcentajeDescuento / 100)).toFixed(2));
        next.precioVentaContado = Number((next.costoReal * next.futContado * factorIva).toFixed(2));
        next.precioVentaLista = Number((next.costoReal * next.futLista * factorIva).toFixed(2));
      } else if (par_origen === "porcentajeDescuento") {
        next.costoReal = Number((next.costoPesos - (next.costoPesos * next.porcentajeDescuento / 100)).toFixed(2));
        next.precioVentaContado = Number((next.costoReal * next.futContado * factorIva).toFixed(2));
        next.precioVentaLista = Number((next.costoReal * next.futLista * factorIva).toFixed(2));
      } else if (par_origen === "futContado") {
        next.precioVentaContado = Number((next.costoReal * next.futContado * factorIva).toFixed(2));
      } else if (par_origen === "precioVentaContado") {
        if (next.costoReal > 0) {
          next.futContado = Number((next.precioVentaContado / factorIva / next.costoReal).toFixed(4));
        } else {
          next.futContado = 0;
        }
      } else if (par_origen === "futLista") {
        next.precioVentaLista = Number((next.costoReal * next.futLista * factorIva).toFixed(2));
      } else if (par_origen === "precioVentaLista") {
        if (next.costoReal > 0) {
          next.futLista = Number((next.precioVentaLista / factorIva / next.costoReal).toFixed(4));
        } else {
          next.futLista = 0;
        }
      }
      return next;
    });
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Dialog
        open={true}
        onClose={(event, reason) => {
          if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
            return;
          }
          handleCloseDialog();
        }}
        disableEscapeKeyDown={true}
        maxWidth="md"
        fullWidth={true}
        scroll="paper"
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {actionCrud === "new"
            ? "Nuevo"
            : actionCrud === "update"
              ? "Editar"
              : actionCrud === "delete"
                ? "Eliminar"
                : ""}{" "}
          {nameItemText}
          <IconButton
            aria-label="close"
            onClick={handleCloseDialog}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <Grid container spacing={1}>
            <Grid item xs={3} >
              <TextField
                sx={{ width: "100%" }}
                inputProps={{
                  inputMode: 'decimal',
                  minLength: 1,
                  onInput: (e) => {
                    let val = e.target.value;
                    val = val.replace(/[^0-9.\-]/g, '');
                    if ((val.match(/\./g) || []).length > 1) {
                      val = val.substring(0, val.length - 1);
                    }
                    const hasMinus = val.startsWith('-');
                    val = (hasMinus ? '-' : '') + val.replace(/-/g, '');
                    e.target.value = val;
                  }
                }}
                id="esferaDesde"
                label="Esfera Desde (-30 a 30)"
                variant="outlined"
                size="small"
                name="esferaDesde"
                value={itemCrudLocal.esferaDesde ?? ""}
                onChange={handleChange}
                disabled={actionCrud === "disable" || actionCrud === "enable" || actionCrud === "delete" || actionCrud === "view"}
              />
            </Grid>

            <Grid item xs={3} >
              <TextField
                sx={{ width: "100%" }}
                inputProps={{
                  inputMode: 'decimal',
                  minLength: 1,
                  onInput: (e) => {
                    let val = e.target.value;
                    val = val.replace(/[^0-9.\-]/g, '');
                    if ((val.match(/\./g) || []).length > 1) {
                      val = val.substring(0, val.length - 1);
                    }
                    const hasMinus = val.startsWith('-');
                    val = (hasMinus ? '-' : '') + val.replace(/-/g, '');
                    e.target.value = val;
                  }
                }}
                id="esferaHasta"
                label="Esfera Hasta (-30 a 30)"
                variant="outlined"
                size="small"
                name="esferaHasta"
                value={itemCrudLocal.esferaHasta ?? ""}
                onChange={handleChange}
                disabled={actionCrud === "disable" || actionCrud === "enable" || actionCrud === "delete" || actionCrud === "view"}
              />
            </Grid>

            <Grid item xs={3} >
              <TextField
                sx={{ width: "100%" }}
                inputProps={{
                  inputMode: 'decimal',
                  minLength: 1,
                  onInput: (e) => {
                    let val = e.target.value;
                    val = val.replace(/[^0-9.\-]/g, '');
                    if ((val.match(/\./g) || []).length > 1) {
                      val = val.substring(0, val.length - 1);
                    }
                    const hasMinus = val.startsWith('-');
                    val = (hasMinus ? '-' : '') + val.replace(/-/g, '');
                    e.target.value = val;
                  }
                }}
                id="cilindroDesde"
                label="Cilindro Desde (-10 a 0)"
                variant="outlined"
                size="small"
                name="cilindroDesde"
                value={itemCrudLocal.cilindroDesde ?? ""}
                onChange={handleChange}
                disabled={actionCrud === "disable" || actionCrud === "enable" || actionCrud === "delete" || actionCrud === "view"}
              />
            </Grid>

            <Grid item xs={3} >
              <TextField
                sx={{ width: "100%" }}
                inputProps={{
                  inputMode: 'decimal',
                  minLength: 1,
                  onInput: (e) => {
                    let val = e.target.value;
                    val = val.replace(/[^0-9.\-]/g, '');
                    if ((val.match(/\./g) || []).length > 1) {
                      val = val.substring(0, val.length - 1);
                    }
                    const hasMinus = val.startsWith('-');
                    val = (hasMinus ? '-' : '') + val.replace(/-/g, '');
                    e.target.value = val;
                  }
                }}
                id="cilindroHasta"
                label="Cilindro Hasta (-10 a 0)"
                variant="outlined"
                size="small"
                name="cilindroHasta"
                value={itemCrudLocal.cilindroHasta ?? ""}
                onChange={handleChange}
                disabled={actionCrud === "disable" || actionCrud === "enable" || actionCrud === "delete" || actionCrud === "view"}
              />
            </Grid>

            <Grid item xs={2.5} >
              <TextField
                sx={{ width: "100%" }}
                // permito numeros decimales con . pero no numeros negativos
                inputProps={{
                  inputMode: 'decimal',
                  pattern: '^[0-9]{1,3}(\\.[0-9]{1,2})?$',
                  minLength: 1,
                  onInput: (e) => {
                    e.target.value = e.target.value.replace(/[^0-9.]/g, '');
                    if ((e.target.value.match(/\./g) || []).length > 1) {
                      e.target.value = e.target.value.substring(0, e.target.value.length - 1);
                    }
                  }
                }}
                id="costoPesos"
                label="Precio Costo $"
                variant="outlined"
                size="small"
                name="costoPesos"
                value={itemCrudLocal.costoPesos ?? ""}
                onChange={handleChange}
                onBlur={() => handleCalculate("costoPesos")}
                disabled={actionCrud === "disable" || actionCrud === "enable" || actionCrud === "delete" || actionCrud === "view"}
              />
            </Grid>

            <Grid item xs={2.5} >
              <TextField
                sx={{ width: "100%" }}
                inputProps={{
                  inputMode: 'decimal',
                  pattern: '^[0-9]{1,3}(\\.[0-9]{1,2})?$',
                  minLength: 1,
                  onInput: (e) => {
                    e.target.value = e.target.value.replace(/[^0-9.]/g, '');
                    if ((e.target.value.match(/\./g) || []).length > 1) {
                      e.target.value = e.target.value.substring(0, e.target.value.length - 1);
                    }
                  }
                }}
                id="costoDolares"
                label="Precio Costo U$S"
                variant="outlined"
                size="small"
                name="costoDolares"
                value={itemCrudLocal.costoDolares ?? ""}
                onChange={handleChange}
                onBlur={() => handleCalculate("costoDolares")}
                disabled={actionCrud === "disable" || actionCrud === "enable" || actionCrud === "delete" || actionCrud === "view"}
              />
            </Grid>

            <Grid item xs={2} >
              <TextField
                sx={{ width: "100%" }}
                inputProps={{
                  inputMode: 'decimal',
                  pattern: '^[0-9]{1,3}(\\.[0-9]{1,2})?$',
                  minLength: 1,
                  onInput: (e) => {
                    e.target.value = e.target.value.replace(/[^0-9.]/g, '');
                    if ((e.target.value.match(/\./g) || []).length > 1) {
                      e.target.value = e.target.value.substring(0, e.target.value.length - 1);
                    }
                  }
                }}
                id="valorDolar"
                label="Valor U$S"
                variant="outlined"
                size="small"
                name="valorDolar"
                onBlur={() => handleCalculate("valorDolar")}
                value={itemCrudLocal.valorDolar ?? ""}
                onChange={handleChange}
                disabled={true}
              />
            </Grid>

            <Grid item xs={2.5} >
              <TextField
                sx={{ width: "100%" }}
                inputProps={{
                  inputMode: 'decimal',
                  pattern: '^[0-9]{1,3}(\\.[0-9]{1,2})?$',
                  minLength: 1,
                  onInput: (e) => {
                    e.target.value = e.target.value.replace(/[^0-9.]/g, '');
                    if ((e.target.value.match(/\./g) || []).length > 1) {
                      e.target.value = e.target.value.substring(0, e.target.value.length - 1);
                    }
                  }
                }}
                id="porcentajeDescuento"
                label="% de Descuento"
                variant="outlined"
                size="small"
                name="porcentajeDescuento"
                onBlur={() => handleCalculate("porcentajeDescuento")}
                value={itemCrudLocal.porcentajeDescuento ?? ""}
                onChange={handleChange}
                disabled={actionCrud === "disable" || actionCrud === "enable" || actionCrud === "delete" || actionCrud === "view"}
              />
            </Grid>

            <Grid item xs={2.5} >
              <TextField
                sx={{ width: "100%" }}
                inputProps={{
                  inputMode: 'decimal',
                  pattern: '^[0-9]{1,3}(\\.[0-9]{1,2})?$',
                  minLength: 1,
                  onInput: (e) => {
                    e.target.value = e.target.value.replace(/[^0-9.]/g, '');
                    if ((e.target.value.match(/\./g) || []).length > 1) {
                      e.target.value = e.target.value.substring(0, e.target.value.length - 1);
                    }
                  }
                }}
                id="costoReal"
                label="Costo Real"
                variant="outlined"
                size="small"
                name="costoReal"
                onBlur={() => handleCalculate("costoReal")}
                value={itemCrudLocal.costoReal ?? ""}
                onChange={handleChange}
                disabled={true}
              />
            </Grid>

            <Grid item xs={3} >
              <TextField
                sx={{ width: "100%" }}
                inputProps={{
                  inputMode: 'decimal',
                  pattern: '^[0-9]{1,3}(\\.[0-9]{1,2})?$',
                  minLength: 1,
                  onInput: (e) => {
                    e.target.value = e.target.value.replace(/[^0-9.]/g, '');
                    if ((e.target.value.match(/\./g) || []).length > 1) {
                      e.target.value = e.target.value.substring(0, e.target.value.length - 1);
                    }
                  }
                }}
                id="futContado"
                label="Fut Contado"
                variant="outlined"
                size="small"
                name="futContado"
                onBlur={() => handleCalculate("futContado")}
                value={itemCrudLocal.futContado ?? ""}
                onChange={handleChange}
                disabled={actionCrud === "disable" || actionCrud === "enable" || actionCrud === "delete" || actionCrud === "view"}
              />
            </Grid>

            <Grid item xs={3} >
              <TextField
                sx={{ width: "100%" }}
                inputProps={{
                  inputMode: 'decimal',
                  pattern: '^[0-9]{1,3}(\\.[0-9]{1,2})?$',
                  minLength: 1,
                  onInput: (e) => {
                    e.target.value = e.target.value.replace(/[^0-9.]/g, '');
                    if ((e.target.value.match(/\./g) || []).length > 1) {
                      e.target.value = e.target.value.substring(0, e.target.value.length - 1);
                    }
                  }
                }}
                id="precioVentaContado"
                label="Precio Vta Contado"
                variant="outlined"
                size="small"
                name="precioVentaContado"
                onBlur={() => handleCalculate("precioVentaContado")}
                value={itemCrudLocal.precioVentaContado ?? ""}
                onChange={handleChange}
                disabled={actionCrud === "disable" || actionCrud === "enable" || actionCrud === "delete" || actionCrud === "view"}
              />
            </Grid>

            <Grid item xs={3} >
              <TextField
                sx={{ width: "100%" }}
                inputProps={{
                  inputMode: 'decimal',
                  pattern: '^[0-9]{1,3}(\\.[0-9]{1,2})?$',
                  minLength: 1,
                  onInput: (e) => {
                    e.target.value = e.target.value.replace(/[^0-9.]/g, '');
                    if ((e.target.value.match(/\./g) || []).length > 1) {
                      e.target.value = e.target.value.substring(0, e.target.value.length - 1);
                    }
                  }
                }}
                id="futLista"
                label="Fut Lista"
                variant="outlined"
                size="small"
                name="futLista"
                onBlur={() => handleCalculate("futLista")}
                value={itemCrudLocal.futLista ?? ""}
                onChange={handleChange}
                disabled={actionCrud === "disable" || actionCrud === "enable" || actionCrud === "delete" || actionCrud === "view"}
              />
            </Grid>

            <Grid item xs={3} >
              <TextField
                sx={{ width: "100%" }}
                inputProps={{
                  inputMode: 'decimal',
                  pattern: '^[0-9]{1,3}(\\.[0-9]{1,2})?$',
                  minLength: 1,
                  onInput: (e) => {
                    e.target.value = e.target.value.replace(/[^0-9.]/g, '');
                    if ((e.target.value.match(/\./g) || []).length > 1) {
                      e.target.value = e.target.value.substring(0, e.target.value.length - 1);
                    }
                  }
                }}
                id="precioVentaLista"
                label="Precio Vta Lista"
                variant="outlined"
                size="small"
                name="precioVentaLista"
                onBlur={() => handleCalculate("precioVentaLista")}
                value={itemCrudLocal.precioVentaLista ?? ""}
                onChange={handleChange}
                disabled={actionCrud === "disable" || actionCrud === "enable" || actionCrud === "delete" || actionCrud === "view"}
              />
            </Grid>

            <Grid item xs={12}>
              <Box
                sx={{ display: "flex", justifyContent: "flex-end", pt: 1 }}
              >
                {actionCrud !== "view" && (
                  <Button
                    sx={{ mr: 1 }}
                    variant="contained"
                    size="small"
                    onClick={handleSave}
                    color={actionCrud === "delete" ? "error" : "primary"}
                    startIcon={
                      actionCrud === "disable" ? (
                        <RemoveCircleOutlineIcon />
                      ) : actionCrud === "enable" ? (
                        <AddCircleOutlineIcon />
                      ) : (
                        actionCrud === "delete" ? <RemoveCircleOutlineOutlinedIcon /> : <SaveIcon />
                      )
                    }
                  >
                    {actionCrud === "delete"
                      ? "Eliminar"
                      : actionCrud === "enable"
                        ? "Habilitar"
                        : "Guardar"}
                  </Button>
                )}
                <Button
                  variant="outlined"
                  size="small"
                  onClick={handleCloseDialog}
                >
                  {actionCrud === "view" ? "Cerrar" : "Cancelar"}
                </Button>
              </Box>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default RangoDialog;
